export default __webpack_public_path__ + "static/microsoft-78dd4a41b7bc3af7ebec21b1093da07b.svg";